import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, mergeMap, Observable } from 'rxjs';
import { DISCLOSE_SECRETS, DISCLOSURES } from '../api/dealer-api';
import { CREATE_INVOICE, DEPOSIT_STATUS, SET_LIGHTNING_ADDRESS } from '../api/jit-api';
import {
  FIND_MATCH,
  FINISH_ROUND,
  START_ROUND,
  TIERS,
  ROOMS,
  LEADERBOARDS,
  WAITING_OPPONENTS,
  ACTIVITY_FEED,
  PRACTICE_ROUNDS,
  TOURNAMENT_PUBLISHED,
  TOURNAMENTS,
  MINI_LEADERBOARD,
  LEADERBOARD,
  USERS,
  INVENTORY,
  SPIN_DAILY_SPINNER,
  SPIN_ROUND_SPINNER,
} from '../api/wager-api';
import { getAuth } from 'firebase/auth';
import { OperatorService } from '../services/operator/operator.service';
import { SignedOutError } from 'src/app/shared/errors/signed-out-error';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authenticatedUrls = [
    DISCLOSE_SECRETS,
    DISCLOSURES,
    SET_LIGHTNING_ADDRESS,
    CREATE_INVOICE,
    DEPOSIT_STATUS,
    FIND_MATCH,
    FINISH_ROUND,
    START_ROUND,
    TIERS,
    ROOMS,
    LEADERBOARDS,
    WAITING_OPPONENTS,
    ACTIVITY_FEED,
    PRACTICE_ROUNDS,
    TOURNAMENT_PUBLISHED,
    TOURNAMENTS,
    MINI_LEADERBOARD,
    LEADERBOARD,
    USERS,
    INVENTORY,
    SPIN_DAILY_SPINNER,
    SPIN_ROUND_SPINNER,
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (OperatorService.IsDemo || !this.requiresAuth(request.url)) {
      return next.handle(request);
    }

    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new SignedOutError(`User signed out from: ${request.url}`, request.url);
    }

    return from(user.getIdToken()).pipe(
      mergeMap((token) => {
        const authRequest = token
          ? request.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            })
          : request;
        return next.handle(authRequest);
      }),
    );
  }

  private requiresAuth(url: string): boolean {
    return this.authenticatedUrls.some((endpoint) => url.includes(endpoint));
  }
}
